
export default function NewsSection() {
  const news = [
    {
      category: 'イベント',
      categoryColor: 'bg-[#4A90E2]',
      date: '2025年4月15日',
      title: '設立記念ウェルビーイングセミナー開催のお知らせ',
      description: '協会設立を記念し、ウェルビーイングの最新動向と実践方法をお伝えするセミナーを開催いたします。専門家による講演とワークショップをご用意しております。',
    },
    {
      category: 'セミナー',
      categoryColor: 'bg-[#FF9F43]',
      date: '2025年4月22日',
      title: '企業向け健康経営オンライン説明会',
      description: '健康経営に取り組みたい企業・団体の皆様へ、当協会のサポートプログラムをご紹介するオンライン説明会を実施します。個別相談も承ります。',
    },
    {
      category: 'イベント',
      categoryColor: 'bg-[#4A90E2]',
      date: '2025年5月10日',
      title: 'ペット×ウェルビーイング体験会のお知らせ',
      description: 'ペットと一緒に参加できる体験イベントを開催。ボディスキャン体験やアニマルセラピーのデモンストレーション、専門家による相談会も実施予定です。',
    },
  ];

  return (
    <section id="news" className="py-32 bg-[#F7F9FB]">
      <div className="max-w-[1200px] mx-auto px-10">
        {/* セクションタイトル */}
        <div className="flex items-end justify-between mb-14">
          <div>
            <p className="text-xs font-semibold tracking-widest bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent mb-4">
              NEWS &amp; EVENTS
            </p>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B3C]">
              お知らせ・イベント情報
            </h2>
          </div>
          <button className="hidden md:flex items-center gap-2 text-sm font-semibold bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent hover:gap-3 transition-all duration-300 cursor-pointer whitespace-nowrap">
            一覧を見る
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        {/* ニュースカード */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {news.map((item, index) => (
            <article
              key={index}
              className="bg-white rounded-[20px] overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="p-8">
                {/* カテゴリと日付 */}
                <div className="flex items-center gap-3 mb-6">
                  <span className={`${item.categoryColor} text-white text-xs font-semibold px-3 py-1.5 rounded-md`}>
                    {item.category}
                  </span>
                  <span className="text-[13px] text-[#5A6C7D]">{item.date}</span>
                </div>

                {/* タイトル */}
                <h3 className="text-lg font-bold text-[#1A2B3C] leading-snug mb-4 line-clamp-2">
                  {item.title}
                </h3>

                {/* 説明 */}
                <p className="text-sm leading-relaxed text-[#3A4A5A] mb-5 line-clamp-3">
                  {item.description}
                </p>

                {/* リンク */}
                <button className="text-sm font-semibold bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent flex items-center gap-2 group hover:gap-3 transition-all duration-300 whitespace-nowrap">
                  続きを読む
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>

        {/* モバイル用一覧ボタン */}
        <div className="md:hidden mt-10 text-center">
          <button className="inline-flex items-center gap-2 text-sm font-semibold bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent cursor-pointer whitespace-nowrap">
            一覧を見る
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
